import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui.min';
import axios from 'axios';
import queryString from 'query-string';
import Calendar from './Calendar';

const MOBILE_BREAKPOINT = 1160;

class ProgramWeek {
    constructor() {
        this.program = document.querySelectorAll('.js-programweek');
        if (this.program.length) {
            this.program.forEach((program) => {
                this.bindProgram(program);
            });
        }
        const $_GET = [];
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (a, name, value) => { $_GET[name] = value; });
        if ($_GET.session) {
            const item = document.querySelector(`.session[data-session-id="${$_GET.session}"]`);
            if (item) {
                item.click();
            }
        }
    }

    bindProgram(program) {
        this.showActiveDayOnMobile(program);
        window.addEventListener('scroll', () => this.showActiveDayOnMobile(program), { passive: true });

        this.render(program);

        program.querySelectorAll('.js-program-toggle').forEach((item) => {
            this.bindToggle(program, item);
        });

        // if (window.localStorage.getItem('type-program')) {
        //     program.querySelector(`.js-program-toggle[data-type="${window.localStorage.getItem('type-program')}"]`).click();
        // }

        program.querySelectorAll('.js-day-toggle').forEach((item) => {
            this.bindDayToggle(program, item);
        });

        this.bindHover(program);
    }

    showActiveDayOnMobile(program) {
        if (window.innerWidth >= MOBILE_BREAKPOINT) {
            return;
        }
        if (program.querySelector('[data-day].visible')) {
            return;
        }

        let dayElement;
        if (window.localStorage.getItem('program-day')) {
            dayElement = program.querySelector(`[data-day="${window.localStorage.getItem('program-day')}"]`);
        } else {
            dayElement = program.querySelector('[data-day]');
        }
        if (dayElement) {
            dayElement.classList.add('visible');
        }
    }

    bindHover(program) {
        const container = program.querySelector('.program-container');
        program.querySelectorAll('.day').forEach((day) => {
            day.addEventListener('mouseenter', () => {
                day.classList.add('hovered');
                container.classList.add('day-hovered');
                this.updateDayWidths(program);
            });

            day.addEventListener('mouseleave', () => {
                day.classList.remove('hovered');
                container.classList.toggle('day-hovered', program.querySelector('.day.hovered'));
                this.updateDayWidths(program);
            });
        });
    }

    bindDayToggle(program, item) {
        item.addEventListener('click', () => {
            if (item.classList.contains('invisible')) {
                return;
            }
            const target = program.querySelector(`[data-day="${item.dataset.dayToggle}"]`);
            if (target) {
                program.querySelector('[data-day].visible').classList.remove('visible');
                target.classList.add('visible');
                window.localStorage.setItem('program-day', item.dataset.dayToggle);
            }
            this.render(program);
        });
    }

    bindToggle(program, item) {
        item.addEventListener('click', () => {
            const selected = program.querySelector('.js-program-toggle.selected');
            if (selected.dataset.type == item.dataset.type) {
                return;
            }
            selected.classList.remove('selected');
            item.classList.add('selected');
            program.dataset.visible = item.dataset.type;
            window.localStorage.setItem('type-program', item.dataset.type);
            this.render(program);
        });
    }

    render(program) {
        program.querySelectorAll('.day').forEach((day) => {
            const classToSelect = `.session.${program.dataset.visible}:not([style*="display: none"])`
            const visibleSessions = day.querySelectorAll(classToSelect);

            if (visibleSessions.length === 0) {
                day.style.display = 'none';
            } else {
                day.style.display = '';
            }
        });

        const days = program.querySelectorAll('.day .content');
        days.forEach((day) => {
            const sessions = day.querySelectorAll('.session');
            const sortedSessions = Array.prototype.slice.call(sessions, 0);
            sortedSessions.sort((a, b) => parseInt(b.style.height) - parseInt(a.style.height)).sort((a, b) => {
                if (parseInt(this.getNbSession(b)) === parseInt(this.getNbSession(a))) {
                    return b.dataset.position - a.dataset.position;
                }
                return parseInt(this.getNbSession(b)) - parseInt(this.getNbSession(a));
            });

            // Reset the width
            sortedSessions.forEach((session) => {
                session.style.width = '100%';
                session.style.left = 0;
            });

            let i = 0;
            // Reset the width
            sortedSessions.forEach((session) => {
                const overlaps = this.getOverlapingDivsWithLowerScore(session, day);
                session.dataset.calculatedOverlap = overlaps.length;
                session.dataset.runNumber = i++;
                session.dataset.nbSessions = this.getNbSession(session);
                if (overlaps.length) {
                    const sortedOverlap = Array.prototype.slice.call(overlaps, 0);
                    sortedOverlap.sort((a, b) => parseInt(this.getNbSession(b)) - parseInt(this.getNbSession(a)));
                    const itemSize = this.getNbSession(sortedOverlap[0]);
                    if (parseInt(session.style.width) > (100 / itemSize)) {
                        session.style.width = `${100 / itemSize}%`;
                    }
                    session.classList.toggle('small', itemSize <= 4);
                    session.dataset.overlaplast = itemSize;

                    const overlapsSame = this.getOverlapingDivsWithHigherScore(session, day, itemSize);

                    // Reducing the size of elements overlaping
                    overlapsSame.forEach((overlapedSession) => {
                        const overlapsWidth = `${100 / itemSize}%`;
                        overlapedSession.style.width = overlapsWidth;
                        overlapedSession.dataset.overlappedSize = itemSize;
                    });

                    // Find an available column
                    let col = itemSize - 1;
                    while (col >= 0 && this.getOverlapingDivsWithHigherScore(session, day, itemSize).length) {
                        session.style.left = `${(100 / itemSize) * col}%`;
                        col--;
                    }
                } else {
                    // Full size take whatever space is remaining
                    const overlapsPlaced = this.getOverlapingDivs(session, day);
                    if (overlapsPlaced.length) {
                        const sortedOverlap = Array.prototype.slice.call(overlapsPlaced, 0);
                        sortedOverlap.sort((a, b) => parseInt(b.style.width) - parseInt(a.style.width));
                        // const itemWidth = parseInt(sortedOverlap[0].style.width);
                        const itemWidth = sortedOverlap.reduce((v, item) => {
                            if (!item.style.width) {
                                return v;
                            }
                            return v + parseInt(item.style.width);
                        }, 0);
                        session.style.width = `${100 - itemWidth}%`;
                        session.dataset.fullsize = itemWidth;

                        if (!parseInt(sortedOverlap[0].style.left)) {
                            session.style.left = `${itemWidth}%`;
                        }
                    }
                    session.classList.toggle('small', parseInt(session.style.width) <= 25);
                }
            });
        });

        this.updateDayWidths(program);
    }

    getNbSession(item) {
        let type = 'Onsite';
        if (window.localStorage.getItem('type-program')) {
            type = window.localStorage.getItem('type-program').charAt(0).toUpperCase() + window.localStorage.getItem('type-program').slice(1);
        }
        return item.dataset[`nbSessions${type}`];
    }

    getOverlapingDivsWithHigherScore(parent, day, score) {
        const list = [];
        if (!score) {
            score = this.getNbSession(parent);
        }
        day.querySelectorAll('.session').forEach((session) => {
            if (session.dataset.sessionId != parent.dataset.sessionId && this.getNbSession(session) >= score && this.isOverlapping(parent, session)) {
                list.push(session);
            }
        });
        return list;
    }

    getOverlapingDivsWithLowerScore(parent, day, score) {
        const list = [];
        if (!score) {
            score = this.getNbSession(parent);
        }
        day.querySelectorAll('.session').forEach((session) => {
            if (session.dataset.sessionId != parent.dataset.sessionId && this.getNbSession(session) <= score && this.isOverlapping(parent, session)) {
                list.push(session);
            }
        });
        return list;
    }

    getOverlapingDivs(parent, day) {
        const list = [];
        day.querySelectorAll('.session').forEach((session) => {
            if (session.dataset.sessionId != parent.dataset.sessionId && this.isOverlapping(parent, session)) {
                list.push(session);
            }
        });
        return list;
    }

    isOverlapping(a, b) {
        if (a.style.display == 'none' || b.style.display == 'none') {
            return false;
        }
        const rect1 = a.getBoundingClientRect();
        const rect2 = b.getBoundingClientRect();

        return !(parseInt(rect1.right) <= parseInt(rect2.left)
            || parseInt(rect1.left) >= parseInt(rect2.right)
            || parseInt(rect1.bottom) <= parseInt(rect2.top)
            || parseInt(rect1.top) >= parseInt(rect2.bottom));
    }

    updateDayWidths(program) {
        const container = program.querySelector('.program-container');
        const days = program.querySelectorAll('.day');
        const visibleDays = Array.from(days).filter((day) => day.style.display !== 'none');

        const count = visibleDays.length;
        if (!count) {
            return;
        }

        const normalWidth = 100 / count;
        const hoverBase = 80 / count;
        const hoveredWidth = hoverBase + 20;

        visibleDays.forEach((day) => {
            if (window.innerWidth < MOBILE_BREAKPOINT) {
                day.style.width = 'calc(100% - 80px)';
            } else if (container.classList.contains('day-hovered') && day.classList.contains('hovered')) {
                day.style.width = `calc(${hoveredWidth}% - ${150 / count}px)`;
            } else if (container.classList.contains('day-hovered')) {
                day.style.width = `calc(${hoverBase}% - ${150 / count}px)`;
            } else {
                day.style.width = `calc(${normalWidth}% - ${150 / count}px)`;
            }
        });
    }
}

export default ProgramWeek;
